export function getInitials(name: string | null | undefined): string {
  if (!name) {
    return "";
  }

  //Get the first letter of the fist and last word.
  //If there's only one word, use the first letter
  const hasTokens = name.indexOf(" ") !== -1;
  return (
    name.substring(0, hasTokens ? 1 : 2) +
    (hasTokens ? name.charAt(name.lastIndexOf(" ") + 1) : "")
  );
}
